import React from 'react';
import TaskIcon from '@mui/icons-material/Task';
import { useVendorId, useVendorsUrl } from 'domain/finance/vendors/routes';
import { useNavigate } from 'react-router-dom';
import { useAuthorization } from 'framework/authorization';
import { useShowContext } from 'framework/show';
import { VendorDto } from 'domain/finance/vendors/types';
import {
  VENDOR_COMPLIANCE_REVIEW,
  VENDOR_PROFILE_STATUSES,
  VENDOR_WORKING_STATUSES,
} from 'domain/finance/vendors/constants';
import { Button } from 'framework/ui/mui-builder';

const ComplianceVendorButton = () => {
  const id = useVendorId();
  const navigate = useNavigate();
  const { isGranted } = useAuthorization();
  const { data } = useShowContext<VendorDto>();
  const { isCompliant, profileStatus, workingStatus } = data.getData();

  const { getComplianceVendorUrl } = useVendorsUrl();

  const handleRedirect = () => {
    navigate(getComplianceVendorUrl(id));
  };

  return isGranted(VENDOR_COMPLIANCE_REVIEW) &&
    !isCompliant &&
    profileStatus === VENDOR_PROFILE_STATUSES.DRAFT &&
    workingStatus === VENDOR_WORKING_STATUSES.INACTIVE ? (
    <Button onClick={handleRedirect} variant="contained" color="primary" startIcon={<TaskIcon />}>
      Compliance
    </Button>
  ) : null;
};

export default ComplianceVendorButton;
